// extracted by mini-css-extract-plugin
export default {"wrapper":"style__wrapper__NG5bL"};